export const environment = {
  // baseUrl: 'https://api.qpretest.dev.jasminesoft.net',
 baseUrl: 'https://api.dev.qpretest.com',
 // baseUrl: 'http://localhost:3210',
};
